<div
  class="modal-content modal-content-right"
  role="dialog"
  aria-label="Add Customer"
>
  <div class="modal-header">
    <h1 class="modal-title" aria-label="Title">
      <i class="far fa-user-circle"></i>
      {{ isEditMode ? "Edit" : "Add" }} Customer
    </h1>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body px-0" role="main">
    <form class="add-customer-form col" #customerForm="ngForm">
      <div class="form-row">
        <div class="col-sm-6">
          <div class="form-group">
            <label>Customer Type</label>
            <select
              name="customerTypeSelect"
              class="form-control"
              [(ngModel)]="model.CustomerTypeId"
              (change)="customerTypeChanged($event)"
              aria-label="Customer Type"
            >
              <option value="1" selected="true">Individual</option>
              <option value="2">Business</option>
            </select>
          </div>
        </div>
        <div class="col-sm-6">
          <label>Location</label>
          <select
            class="form-control"
            [(ngModel)]="model.LocationId"
            name="LocationId"
            aria-label="Location"
          >
            <option disabled>Select location...</option>
            <option *ngFor="let loc of locations" value="{{ loc.Id }}">
              {{ loc.BranchName }}
            </option>
          </select>
        </div>
      </div>

      <div class="row" *ngIf="isIndividual">
        <div class="col-sm-12">
          <h2>Personal Details</h2>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label>Display Photo</label>
            <div class="photo">
              <img
                src="{{
                  customerPhotoLoading
                    ? 'assets/images/preloader.gif'
                    : model.Photo
                }}"
                alt="Customer Photo"
              />
            </div>
            <div class="change-photo">
              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                (change)="encodeImageFileAsURL($event)"
                #customerPhoto
                style="display: none"
                aria-label="File"
              />
              <a href="javascript:void(0)" (click)="customerPhoto.click()"
                ><i class="fas fa-image"></i>Change photo</a
              >
            </div>
          </div>
        </div>

        <div class="col-sm-9">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label>First name</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="First name"
                  (blur)="preventPureSpaces($event)"
                  [(ngModel)]="model.FirstName"
                  required
                  [ngClass]="{
                    'is-invalid': model.FirstName == null || !FirstName.valid
                  }"
                  #FirstName="ngModel"
                  name="Firstname"
                  aria-label="Firstname"
                />
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label>Last name</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Last name"
                  (blur)="preventPureSpaces($event)"
                  [(ngModel)]="model.LastName"
                  required
                  [ngClass]="{ 'is-invalid': !LastName.valid }"
                  #LastName="ngModel"
                  name="Lastname"
                  aria-label="Lastname"
                />
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label>Birthday</label>
                <input
                  type="date"
                  class="form-control"
                  [(ngModel)]="model.Birthday"
                  name="Birthday"
                  [max]="maxDate"
                  aria-label="Birthday"
                />
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label>Job Title</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="model.JobTitle"
                  name="JobTitle"
                  placeholder="-"
                  aria-label="JobTitle"
                />
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label>Email address</label>
                <input
                  type="email"
                  class="form-control"
                  placeholder="Email Address"
                  (blur)="preventPureSpaces($event)"
                  [(ngModel)]="model.EmailAddress"
                  required
                  [ngClass]="{
                    'is-invalid': !EmailAddress.valid || !emailAddressValid
                  }"
                  #EmailAddress="ngModel"
                  name="EmailAddress"
                  aria-label="Email Address"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>About</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="model.About"
                  name="About"
                  placeholder="-"
                  aria-label="About"
                />
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label>Customer reference ID</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  onPaste="return false"
                  (keypress)="checkSpecialChar($event)"
                  [(ngModel)]="model.CustomerRefID"
                  name="CustomerRefID"
                  aria-label="Reference ID"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>Customer VAT registration #</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  onPaste="return false"
                  (keypress)="checkSpecialChar($event)"
                  [(ngModel)]="model.CustomerVATRegistrationNumber"
                  name="CustomerVATRegistrationNumber"
                  aria-label="Customer VAT registration #"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="!isIndividual">
        <div class="col-sm-12">
          <h2>Business Details</h2>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label>Display Photo</label>
            <div class="photo">
              <img
                src="{{
                  customerPhotoLoading
                    ? 'assets/images/preloader.gif'
                    : model.Photo
                }}"
                style="width: 150px"
                alt="Business Photo"
              />
            </div>
            <div class="change-photo">
              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                (change)="encodeImageFileAsURL($event)"
                #customerPhoto
                style="display: none"
                aria-label="File"
              />
              <a href="javascript:void(0)" (click)="customerPhoto.click()"
                ><i class="fas fa-image"></i> CHANGE PHOTO</a
              >
            </div>
          </div>
        </div>

        <div class="col-sm-9">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Business Name</label>
                <div class="form-row">
                  <div class="col-sm-6">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Business Name"
                      [(ngModel)]="model.BusinessName"
                      name="BusinessName"
                      (blur)="preventPureSpaces($event)"
                      required
                      [ngClass]="{ 'is-invalid': !BusinessName.valid }"
                      #BusinessName="ngModel"
                      aria-label="Business Name"
                    />
                  </div>
                  <div class="col-sm-6">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Nature Of Business"
                      [(ngModel)]="model.BusinessNature"
                      name="BusinessNature"
                      aria-label="Nature of Business"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label>Customer reference ID</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  onPaste="return false"
                  (keypress)="checkSpecialChar($event)"
                  [(ngModel)]="model.CustomerRefID"
                  name="CustomerRefID"
                  aria-label="Reference ID"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>Customer VAT registration #</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  onPaste="return false"
                  (keypress)="checkSpecialChar($event)"
                  [(ngModel)]="model.CustomerVATRegistrationNumber"
                  name="CustomerVATRegistrationNumber"
                  aria-label="Customer VAT registration #"
                />
              </div>
            </div>

            <div class="col-sm-12" *ngIf="isIndividual">
              <h2 class="mt-3 mb-2">Contact Person</h2>
            </div>

            <div class="col-sm-6" *ngIf="isIndividual">
              <div class="form-group">
                <label>Fullname</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="First name"
                  [(ngModel)]="contactmodel.FirstName"
                  required
                  [ngClass]="{ 'is-invalid': !contactFirstName.valid }"
                  #contactFirstName="ngModel"
                  (blur)="preventPureSpaces($event)"
                  name="contactFirstName"
                  aria-label="Contact Person Firstname"
                />
              </div>
            </div>

            <div class="col-sm-6" *ngIf="isIndividual">
              <div class="form-group">
                <label></label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Last name"
                  [(ngModel)]="contactmodel.LastName"
                  required
                  [ngClass]="{ 'is-invalid': !contactLastName.valid }"
                  #contactLastName="ngModel"
                  (blur)="preventPureSpaces($event)"
                  name="contactLastName"
                  aria-label="Contact Person Lastname"
                />
              </div>
            </div>

            <div class="col-sm-6" *ngIf="isIndividual">
              <div class="form-group">
                <label>Email address</label>
                <input
                  type="email"
                  class="form-control"
                  placeholder="Email address"
                  [(ngModel)]="contactmodel.EmailAddress"
                  required
                  [ngClass]="{
                    'is-invalid':
                      !contactEmailAddress.valid || !emailAddressValid
                  }"
                  #contactEmailAddress="ngModel"
                  name="contactEmailAddress"
                  aria-label="Email Address"
                />
              </div>
            </div>

            <div class="col-sm-6" *ngIf="isIndividual">
              <div class="form-group">
                <label>Department</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="contactmodel.Department"
                  name="contactDepartment"
                  aria-label="Department"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12" *ngIf="!isEditMode">
          <h2>Customer Contact</h2>

          <app-contact-form
            [usStates]="usStates"
            [countries]="countries"
          ></app-contact-form>
        </div>
      </div>

      <hr *ngIf="!isEditMode && isIndividual" />

      <div class="row" *ngIf="!isEditMode && isIndividual">
        <div class="col-md-12">
          <h2>Contact Information</h2>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Phone Type</label>
            <select
              name="phonetypeSelect"
              class="form-control"
              [(ngModel)]="phonemodel.PhoneType"
              name="phonemodelPhoneType"
              aria-label="Phone Type"
            >
              <option value="1">Mobile</option>
              <option value="2">Home</option>
              <option value="3">Office</option>
            </select>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label>Contact number</label>
            <input
              type="tel"
              class="form-control"
              placeholder="Mobile, Homephone, etc."
              maxlength="14"
              [(ngModel)]="phonemodel.PhoneNumber"
              name="phoneModelPhoneNumber"
              (keyup)="onMobileNumberKeyup($event.target.value)"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              aria-label="Contact Number"
            />
          </div>
        </div>
        <div class="col-sm-12 text-right">
          <button
            type="button"
            class="btn btn-outline"
            (click)="addNewContactNumber()"
            [disabled]="!phonemodel.PhoneNumber"
          >
            <i class="fas fa-plus"></i> Add customer phone
          </button>
        </div>
      </div>
      <div class="form-row" *ngIf="!isEditMode && isIndividual">
        <div class="form-group col-md-12">
          <h2>Contact Numbers</h2>
          <table
            class="table table-bordered"
            width="100%"
            style="padding: 10px"
          >
            <thead class="thead-light" style="padding: 10px">
              <tr>
                <th width="15%">Type</th>
                <th width="75%">Mobile Number</th>
                <th width="10%">Action</th>
              </tr>
            </thead>
            <tbody style="padding: 10px">
              <tr
                *ngIf="
                  !customerContactNumbers || !customerContactNumbers.length
                "
              >
                <td colspan="3" class="text-center">No contact number yet.</td>
              </tr>
              <tr
                style="padding: 10px"
                *ngFor="
                  let individualContactNumber of customerContactNumbers;
                  let i = index
                "
              >
                <td *ngIf="individualContactNumber.PhoneType == 1" width="15%">
                  Mobile
                </td>
                <td *ngIf="individualContactNumber.PhoneType == 2" width="15%">
                  Home
                </td>
                <td *ngIf="individualContactNumber.PhoneType == 3" width="15%">
                  Office
                </td>
                <td width="75%">
                  {{ individualContactNumber.PhoneNumber }}
                </td>
                <td align="center" width="10%">
                  <button
                    type="button"
                    title="Remove address"
                    class="btn btn-sml btn-secondary"
                    (click)="removeContactNumber(i)"
                  >
                    <small><i class="fas fa-minus-circle"></i></small>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!--start address-->
      <hr *ngIf="!isEditMode && isIndividual" />

      <div class="row" *ngIf="!isEditMode && isIndividual">
        <div class="col-sm-12">
          <h2>Address</h2>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label>Address Type</label>
            <select
              name="addresstypeSelect"
              class="form-control"
              [(ngModel)]="addressmodel.AddressType"
              aria-label="Address Type"
            >
              <option value="1">Home</option>
              <option value="2">Office</option>
              <option value="3">Shipping</option>
              <option value="4">Billing</option>
            </select>
          </div>

          <div *ngIf="isDefaultSelected == false" class="custom-checkbox">
            <input
              type="checkbox"
              id="rememberMe"
              name="IsDefault"
              [(ngModel)]="addressmodel.IsDefault"
              style="vertical-align: middle"
            />
            <label class="custom-control-label" for="rememberMe"
              >Set Default</label
            >
          </div>
        </div>

        <div class="col-sm-9">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Address</label>
                <input
                  type="text"
                  class="form-control"
                  [required]="addressFieldRequiresValue()"
                  [(ngModel)]="addressmodel.StreetAddress"
                  placeholder="Street address"
                  (blur)="preventPureSpaces($event)"
                  [ngClass]="{ 'is-invalid': !StreetAddress.valid }"
                  #StreetAddress="ngModel"
                  name="StreetAddress"
                  placeholder="Street Address"
                />
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="addressmodel.Address2"
                  placeholder="Address 2"
                  name="Address2"
                  placeholder="Address 2"
                />
              </div>
            </div>

            <div class="col-sm-6 pr-2">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  [required]="addressFieldRequiresValue()"
                  [(ngModel)]="addressmodel.City"
                  placeholder="City"
                  (blur)="preventPureSpaces($event)"
                  [ngClass]="{ 'is-invalid': !City.valid }"
                  #City="ngModel"
                  name="City"
                />
              </div>
            </div>

            <div class="col-sm-6 pl-2">
              <div class="form-group">
                <select
                  class="form-control"
                  [required]="addressFieldRequiresValue() && isUSA"
                  [(ngModel)]="addressmodel.State"
                  [disabled]="!isUSA"
                  [ngClass]="{ 'is-invalid': !State.valid && isUSA }"
                  placeholder="State"
                  #State="ngModel"
                  name="State"
                  aria-label="Stype"
                >
                  <option disabled selected value="">State</option>
                  <option
                    *ngFor="let state of usStates"
                    value="{{ state.abbreviation }}"
                  >
                    {{ state.abbreviation }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-sm-6 pr-2">
              <div class="form-group">
                <select
                  class="form-control"
                  [required]="addressFieldRequiresValue()"
                  [(ngModel)]="addressmodel.CountryId"
                  (change)="countryChanged($event)"
                  [ngClass]="{ 'is-invalid': !CountryId.valid }"
                  #CountryId="ngModel"
                  name="CountryId"
                  aria-label="Country"
                >
                  <option hidden>-Select a country-</option>
                  <option
                    *ngFor="let country of countries"
                    value="{{ country.Id }}"
                  >
                    {{ country.CountryName }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-sm-6 pl-2">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  [required]="addressFieldRequiresValue()"
                  [(ngModel)]="addressmodel.ZipCode"
                  placeholder="Zip Code"
                  name="addressmodelZipcode"
                  (blur)="preventPureSpaces($event)"
                  [ngClass]="{ 'is-invalid': !ZipCode.valid }"
                  #ZipCode="ngModel"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-3">&nbsp;</div>
        <div class="col-sm-9">
          <div
            class="form-group text-right"
            *ngIf="model.LevelProcessing == 2 || model.LevelProcessing == 3"
          >
            <label
              ><span style="font-weight: bold; color: red">Note: </span>Shipping
              Address is required for Level 2 or 3 customers.</label
            >
          </div>
          <div class="form-group text-right">
            <button
              type="button"
              class="btn btn-outline"
              (click)="addNewCustomerAddress()"
              [disabled]="busy"
            >
              <i class="fas fa-plus"></i> Add another address
            </button>
          </div>
        </div>
      </div>

      <hr *ngIf="!isEditMode && isIndividual" />

      <div class="form-row" *ngIf="!isEditMode && isIndividual">
        <div class="form-group col-md-12">
          <h2>Addresses</h2>
          <table
            class="table table-bordered"
            width="100%"
            style="padding: 10px"
          >
            <thead class="thead-light" style="padding: 10px">
              <tr>
                <th width="15%">Type</th>
                <th width="75%">Address</th>
                <th width="10%">Action</th>
              </tr>
            </thead>
            <tbody style="padding: 10px">
              <tr *ngIf="!customeraddresses || !customeraddresses.length">
                <td colspan="3" class="text-center">No address yet.</td>
              </tr>
              <tr
                style="padding: 10px"
                *ngFor="
                  let individualaddress of customeraddresses;
                  let i = index
                "
              >
                <td *ngIf="individualaddress.AddressType == 1" width="15%">
                  Home
                </td>
                <td *ngIf="individualaddress.AddressType == 2" width="15%">
                  Office
                </td>
                <td *ngIf="individualaddress.AddressType == 3" width="15%">
                  Shipping
                </td>
                <td *ngIf="individualaddress.AddressType == 4" width="15%">
                  Billing
                </td>
                <td width="75%">
                  {{ individualaddress.StreetAddress }}
                  {{ individualaddress.Address2 }} {{ individualaddress.City }}
                  {{ individualaddress.State }} {{ individualaddress.County }}
                  {{ individualaddress.ZipCode }}
                </td>
                <td align="center" width="10%">
                  <button
                    type="button"
                    title="Remove address"
                    class="btn btn-sml btn-secondary"
                    (click)="remove(individualaddress, i)"
                  >
                    <small><i class="fas fa-minus-circle"></i></small>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h2>Invoice Settings</h2>
        </div>
        <div class="col-md-12">
          <div class="d-flex">
            <label class="form-label"></label>
            <div class="custom-control custom-switch my-2">
              <input
                type="checkbox"
                class="custom-control-input"
                name="taxExempted"
                id="taxExempted"
                [(ngModel)]="model.IsTaxExempt"
              />
              <label class="custom-control-label" for="taxExempted"
                >Tax Exempted</label
              >
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Number</label>
            <input
              type="number"
              min="0"
              [(ngModel)]="model.PaymentTermCount"
              [ngModelOptions]="{ standalone: true }"
              class="form-control"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Payment Term</label>
            <select
              class="form-control"
              [(ngModel)]="model.PaymentTerm"
              [ngModelOptions]="{ standalone: true }"
            >
              <option value="" selected>-Select-</option>
              <option value="Days">Days</option>
              <option value="Weeks">Weeks</option>
              <option value="Months">Months</option>
            </select>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-prim"
      (click)="save()"
      [disabled]="
        busy ||
        !customerForm.form.valid ||
        !isValidAddress() ||
        (contactForm !== undefined && !contactForm?.customerForm.valid)
      "
    >
      {{ isEditMode ? "Update Customer" : "Add new Customer" }}
      <span *ngIf="busy"> <i class="fas fa-spinner fa-spin"></i></span>
    </button>
  </div>
</div>
